// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"TooltipWrapper_tooltipWrapper__mjoAm","infoIcon":"TooltipWrapper_infoIcon__fb3g1","tooltip":"TooltipWrapper_tooltip__0iUIS"};